import { ColumnsType } from 'antd/lib/table';
import { StyledResourceCompaniesCard } from 'app/components/LayoutComponents/LayoutComponents';
import { StyledTable } from 'app/components/StyledTable/StyledTable';
import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toFixedIfFloat } from 'utils/helpers';
import { useResourceSlice } from '../../slice';
import {
  selectHarvestByCultureAndCompanyState,
  selectSelectedHarvestCulture,
} from '../../slice/selectors';
import { IHarvestByCultureAndCompanyListItem } from '../../slice/types';

interface IProps {}

const HarvestByCultureAndCompanyCard: FC<IProps> = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { actions } = useResourceSlice();

  const envId = useSelector(selectSelectedEnvId) as number;
  const companyId = useSelector(selectSelectedCompanyId);
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);
  const { harvestByCultureAndCompanyArr, loading } = useSelector(
    selectHarvestByCultureAndCompanyState,
  );

  const selectedCulture = useSelector(selectSelectedHarvestCulture);
  useEffect(() => {
    if (selectedCulture) {
      dispatch(
        actions.getHarvestByCultureAndCompany({
          envId,
          cultureId: selectedCulture.id,
          companyId,
          companyGroupId,
        }),
      );
    }
  }, [selectedCulture, companyId, companyGroupId, envId, dispatch, actions]);

  const columns = useMemo(
    (): ColumnsType<IHarvestByCultureAndCompanyListItem> => [
      {
        title: t('Resource.CompaniesCard.Company', 'Company'),
        dataIndex: 'name',
        key: 'name',
        render: (
          _: unknown,
          harvestItem: IHarvestByCultureAndCompanyListItem,
        ) => harvestItem.company.name,
        sorter: {
          compare: (
            a: IHarvestByCultureAndCompanyListItem,
            b: IHarvestByCultureAndCompanyListItem,
          ) => {
            return a.company.name.localeCompare(b.company.name);
          },
        },
      },
      {
        title: t('Resource.CompaniesCard.Balance', {
          defaultValue: 'Balance ({{units}})',
          units: 'T',
        }),
        dataIndex: 'harvest',
        key: 'harvest',
        render: (harvest: number) => toFixedIfFloat(harvest),
        sorter: {
          compare: (
            a: IHarvestByCultureAndCompanyListItem,
            b: IHarvestByCultureAndCompanyListItem,
          ) => {
            return a.harvest - b.harvest;
          },
        },
      },
    ],
    [t],
  );

  if (!selectedCulture) {
    return null;
  }

  return (
    <StyledResourceCompaniesCard bordered={false} title={selectedCulture?.name}>
      <StyledTable
        rowKey={company => company.company.id}
        loading={loading}
        bordered={true}
        columns={columns}
        dataSource={harvestByCultureAndCompanyArr}
        pagination={false}
      />
    </StyledResourceCompaniesCard>
  );
};

export default HarvestByCultureAndCompanyCard;
